/**
 * @generated SignedSource<<8b5bff16e591adecca220bf9cf200835>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ActivityVerb = "FINISHED" | "IN_PROGRESS" | "WISHLIST" | "%future added value";
export type Visibility = "DIRECT" | "PRIVATE" | "PUBLIC" | "UNLISTED" | "%future added value";
export type MarkEntityInput = {
  id: string;
  message?: string | null;
  rating?: number | null;
  share_to_mastodon?: boolean | null;
  verb: ActivityVerb;
  visibility: Visibility;
};
export type MoviePageMarkEntityMutation$variables = {
  connections: ReadonlyArray<string>;
  input: MarkEntityInput;
};
export type MoviePageMarkEntityMutation$data = {
  readonly mark_entity: {
    readonly __typename: string;
    readonly activity?: {
      readonly comment: string;
      readonly created_at: string;
      readonly id: string;
      readonly rating: number | null;
      readonly verb: ActivityVerb;
    };
    readonly message?: string;
  };
};
export type MoviePageMarkEntityMutation = {
  response: MoviePageMarkEntityMutation$data;
  variables: MoviePageMarkEntityMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Activity",
  "kind": "LinkedField",
  "name": "activity",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verb",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "comment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rating",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created_at",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MoviePageMarkEntityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "mark_entity",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/)
            ],
            "type": "MarkEntityPayload",
            "abstractKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MoviePageMarkEntityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "mark_entity",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "prependNode",
                "key": "",
                "kind": "LinkedHandle",
                "name": "activity",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  },
                  {
                    "kind": "Literal",
                    "name": "edgeTypeName",
                    "value": "ActivityEdge"
                  }
                ]
              }
            ],
            "type": "MarkEntityPayload",
            "abstractKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2d2dfc2f68173eda4c02a57042c3d1a9",
    "id": null,
    "metadata": {},
    "name": "MoviePageMarkEntityMutation",
    "operationKind": "mutation",
    "text": "mutation MoviePageMarkEntityMutation(\n  $input: MarkEntityInput!\n) {\n  mark_entity(input: $input) {\n    __typename\n    ... on MarkEntityPayload {\n      activity {\n        id\n        verb\n        comment\n        rating\n        created_at\n      }\n    }\n    ... on Error {\n      __isError: __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "55481723810d1f784dff38bb3273c0bf";

export default node;
